export const attribute = (l10n = {}, it = {}, enchant = 0) => {
    const optionList = it.optionList ?? []
    const classOptionList = it.classOptionList ?? [];
    const enchantOptionData = it.enchantBonusList ? it.enchantBonusList[enchant] : [];
    const invokeOptions = it.invoke ? [it.invoke] : [];

    if (enchantOptionData.length) applyEnchantsToDatas(classOptionList, optionList, invokeOptions, enchantOptionData);

    return `
    <section class="attribute">
        <header>
            <h3>${l10n['item.itemInfo']}</h3>
            <button class="btn-folder is-active"></button>
        </header>
        <article class="is-active">
            <ul>
                ${
                    it.itemClassList?.length < 1
                        ? ``
                        : `
                <li>
                    <div class="key">${l10n['item.class']}</div>
                    <div class="value">${it.itemClassList?.map((cls) => cls.className).join(' / ')}</div>
                </li>
                `
                }
                ${getOptionListTmpl(it.optionList, l10n)}
                ${getClassOptionListTmpl(it.classOptionList, l10n)}
                ${getInvokeOptionListTmpl(invokeOptions, l10n)}
                ${
                    it.socketCount < 1
                        ? ``
                        : `
                <li>
                    <div class="key">${l10n['item.imbueProperty']}</div>
                    <div class="value">${(() => {
                        let sockets = '';
                        for (let i = 0; i < it.socketCount; i++) {
                            sockets += '<span class="value-elemental"></span>';
                        }
                        return sockets;
                    })()}</div>
                </li>
                `
                }
                ${  
                    !it.tier
                        ? `` 
                        : `
                <li>
                    <div class="key">${l10n['item.tier']}</div>
                    <div class="value">${it.tier}</div>
                </li>
                `
                }
                ${
                    !it.material
                        ? ``
                        : `
                <li>
                    <div class="key">${l10n['item.material']}</div>
                    <div class="value">${it.material}</div>
                </li>
                `
                }
                <li>
                    <div class="key">${l10n['item.weight']}</div>
                    <div class="value">${it.weight ? parseFloat(it.weight / 100).toFixed(2) : '0.00'}</div>
                </li>
                ${
                    !it.storyDescription
                        ? ``
                        : `
                <li>
                    <div class="key">${l10n['item.description']}</div>
                    <div class="value">${it.storyDescription?.replace(/\n/gi, '<br>')}</div>
                </li>
                `
                }
            </ul>
        </article>
    </section>`;
};

function applyEnchantsToDatas(classOptionList, optionList, invokeOptions, enchantOptionData) {
    applyEnchantBonusToClassOptions(classOptionList, enchantOptionData);
    applyEnchantBonusToOptions(optionList, enchantOptionData);
    addEnchantsToInvokeOptions(invokeOptions, enchantOptionData);
    applyRestEnchantBonusToOptions(optionList, enchantOptionData);
    addRestEnchantsToOptions(optionList, enchantOptionData);

    // 1. `클래스 옵션 목록 > 클래스 옵션 + enchant 보너스(파란색)` 표시
    function applyEnchantBonusToClassOptions(classOptionList, enchantOptionData) {
        classOptionList.forEach((cop) => {
            cop.optionList.forEach((op) => {
                const matchedEnchant = enchantOptionData.find((enchant) => {
                    const { classId, type, typeSub } = enchant;
                    return typeof classId !== undefined && classId === op.classId && type === op.type && typeSub === op.typeSub;
                });

                if (matchedEnchant) {
                    matchedEnchant.isMatched = true;
                    
                    op.displayValue = addEnchantBonus(op.displayValue, matchedEnchant);
                }
            });
        });
    }

    // 2. 남은 enchants 사용하여 `옵션 목록 > 일반 옵션 + enchant 보너스(파란색)`으로 1차 표시
    function applyEnchantBonusToOptions(optionList, enchantOptionData) {
        const unmatchedEnchantOptions = enchantOptionData.filter(enchant => !enchant.isMatched);
        unmatchedEnchantOptions.forEach((enchant) => {
            optionList.forEach((op) => {
                if (op.typeSub !== 0 && enchant.typeSub !== 0 && op.typeSub === enchant.typeSub) {
                    enchant.isMatched = true;

                    op.displayValue = addEnchantBonus(op.displayValue, enchant);
                }
            });
        });
    }

    // 3. 남은 enchants 사용하여 `invoke(발동) 옵션`으로 표시
    function addEnchantsToInvokeOptions(invokeOptions, enchantOptionData) {
        const unmatchedEnchantOptions = enchantOptionData.filter(enchant => !enchant.isMatched);
        unmatchedEnchantOptions.forEach((enchant) => {
            if (enchant.displayValue && enchant.invokeEffectCategory !== undefined) {
                enchant.isMatched = true;
                enchant.displayValue = `<em>${enchant.displayValue}</em>`;

                invokeOptions.push(enchant);
            }
        });
    }

    // 4. 남은 enchants 사용하여 `옵션 목록 > 일반 옵션 + enchant 보너스(파란색)`에 다시 2차 표시
    function applyRestEnchantBonusToOptions(optionList, enchantOptionData) {
        const unmatchedEnchantOptions = enchantOptionData.filter(enchant => !enchant.isMatched);
        unmatchedEnchantOptions.forEach((enchant) => {
            if (enchant.displayValue) {
                const option = optionList.find((op) => op.type === enchant.type);
                if (option) {
                    enchant.isMatched = true;

                    option.displayValue = addEnchantBonus(option.displayValue, enchant);
                }
            }
        });
    }

    // 5. 남은 enchants 사용하여 `옵션 목록 > 파란색 옵션` 표시
    function addRestEnchantsToOptions(optionList, enchantOptionData) {
        const unmatchedEnchantOptions = enchantOptionData.filter(enchant => !enchant.isMatched);
        unmatchedEnchantOptions.forEach((enchant) => {
            if (enchant.displayValue) {
                    enchant.isMatched = true;
                    enchant.displayValue = `<em>${enchant.displayValue}</em>`;

                    optionList.push(enchant);
            }
        });
    }

    function addEnchantBonus(displayValue, enchant) {
        const { prefixDescription, value, suffixDescription } = enchant;
        return `${displayValue}&nbsp;<em>${prefixDescription ?? ''}${!!value && value !== '0' ? value + (suffixDescription ?? '') : ''}</em>`;
    }
}

function getOptionListTmpl(optionList = [], l10n = {}) {
    if (!optionList?.length) return '';

    return `
    <li>
        <div class="key">${l10n['item.option']}</div>
        <div class="value">
            ${optionList?.map((op) => `<p data-type="${op.type}">${op.displayValue}</p>`).join('') || ''}
        </div>
    </li>`;
}

function getClassOptionListTmpl(classOptionList = [], l10n = {}) {
    if (!classOptionList?.length) return '';

    return `
    <li>
        <div class="key">${l10n['item.classOption']}</div>
        <div class="value">
            ${classOptionList?.map((op) => {
                return `
                    <div>${op.class?.className}</div>
                    <ul class="class-opts">
                        ${op.optionList?.map((cop) => `<li data-type="${cop.type}">${cop.displayValue}</li>`).join('') || ''}
                    </ul>
                `;
            }).join('') || ''}
        </div>
    </li>`;
}

function getInvokeOptionListTmpl(invokeOptionList = [], l10n = {}) {
    if (!invokeOptionList?.length) return '';

    return `
    <li>
        <div class="key">${l10n['item.trigger']}</div>
        <div class="value">
            ${invokeOptionList.map((inv) => {
                if (inv.invokeSpellId) {
                    return `<button data-detailshow="spell_${inv.invokeSpellId}">${inv.displayValue}</button>`;
                }
                return inv.displayValue;
            })
            .join('')}
        </div>
    </li>`;
}